import React from 'react';

const CategoryHero = ({ category }) => {
    const hero = category.hero || {
        title: `${category.name} Medicines`,
        subtitle: 'Affordable Life-Saving Medications From India',
        pills: [
            `${category.productCount || '150+'} Medicines`,
            'Save up to 85%',
            'Worldwide Delivery'
        ]
    };

    return (
        <section className="bg-[#D92D20] py-14 text-white text-center">
            <div className="container mx-auto px-4 mt-16">
                <h1 className="text-4xl md:text-6xl font-black mb-4 tracking-tighter italic">{hero.title}</h1>
                <p className="text-lg md:text-xl text-red-50 max-w-3xl mx-auto font-medium opacity-90 mb-8">
                    {hero.subtitle}
                </p>

                <div className="flex flex-wrap justify-center gap-3">
                    {hero.pills.map((pill, idx) => (
                        <div key={idx} className="bg-white/10 backdrop-blur-md px-5 py-2 rounded-full border border-white/20 text-xs font-black uppercase tracking-widest shadow-xl">
                            {pill}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CategoryHero;
